import {
  REPORTS_SUMMARY,
  REPORTS_REPORT,
  REPORTS_BACKTESTING,
  PORTFOLIOS_FUNDS,
  PORTFOLIOS_BENCHMARKS,
  REPORTS_CONFIG_REPORT,
  PORTFOLIOS_MAPPINGS,
} from '../../../routes';

export const NON_RUN_REPORT_HEADER_ITEMS = [
  {
    displayValue: 'Config',
    path: REPORTS_CONFIG_REPORT,
  },
];

export const REPORTS_HEADER_ITEMS = [
  {
    displayValue: 'Summary',
    path: REPORTS_SUMMARY,
  },
  {
    displayValue: 'Report',
    path: REPORTS_REPORT,
  },
  {
    displayValue: 'Backtesting',
    path: REPORTS_BACKTESTING,
  },
  {
    displayValue: 'Config',
    path: REPORTS_CONFIG_REPORT,
  },
];

export const PORTFOLIOS_HEADER_ITEMS = [
  {
    displayValue: 'Funds',
    path: PORTFOLIOS_FUNDS,
  },
  {
    displayValue: 'Benchmarks',
    path: PORTFOLIOS_BENCHMARKS,
  },
  {
    displayValue: 'Mappings',
    path: PORTFOLIOS_MAPPINGS,
  },
];
